import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useMe } from '../app/auth';
import { Empty } from '../components/ui';
import { draftStore } from '../drafts/store';
import { discardDraft } from '../drafts/sync';
import type { Draft } from '../drafts/types';
import { formatDateTime } from '../lib/dates';

/** Yalnızca bu cihazdaki ve bu hesabın taslakları (T22). Cihaz kaybında bulut yedeği garanti edilmez (PDF §13). */
export function DraftsScreen() {
  const me = useMe();
  const [drafts, setDrafts] = useState<Draft[] | null>(null);
  const load = () => void draftStore().then((s) => s.list(me.user.id)).then((l) => setDrafts(l.filter((d) => d.state !== 'POSTED')));
  useEffect(load, [me.user.id]);

  return (
    <div>
      <div className="row"><h1 style={{ margin: 0 }}>Taslaklarım</h1><span className="spacer" /><Link className="btn primary" to="/fis-ekle">＋ Yeni fiş</Link></div>
      <p className="small muted">Taslaklar yalnızca bu cihazda saklanır ve toplamlara girmez. Uygulamayı silmek veya tarayıcı verilerini temizlemek taslakları kaybettirebilir.</p>
      <div className="card">
        <ul className="list">
          {drafts?.map((d) => (
            <li key={d.id}>
              <div className="item">
                <Link to={`/fis-ekle/${d.id}`} style={{ flex: 1, minWidth: 0, padding: 0 }}>
                  <div>
                    <div className="title">{d.fields.category || d.fields.description || 'Adsız taslak'}</div>
                    <div className="small muted">{d.images.length} görsel · {formatDateTime(new Date(d.updatedAt).toISOString())}{d.lastError ? ` · ${d.lastError.message}` : ''}</div>
                  </div>
                </Link>
                <span className="badge">{d.state === 'REVIEW_REQUIRED' ? 'İncelemede' : d.state === 'FAILED' ? 'Gönderilemedi' : 'Taslak'}</span>
                <button className="btn small danger" onClick={() => { if (confirm('Taslak silinsin mi?')) void discardDraft(d).then(load); }}>Sil</button>
              </div>
            </li>
          ))}
        </ul>
        {drafts && !drafts.length && <Empty>Bekleyen taslak yok.</Empty>}
      </div>
    </div>
  );
}
